// import { canUseDOM } from 'exenv';

export function companyLoading(resp = {}, store = {}) {
  return {
    type: 'COMPANY_LOADING',
    company: resp,
    store
  };
}

export function companyLoaded(resp = {}, store = {}) {
  return {
    type: 'COMPANY_LOADED',
    company: resp,
    store
  };
}

export function companyLoadError(error, store = {}) {
  return {
    type: 'COMPANY_ERROR',
    company: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
